import React from 'react';
import PropTypes from 'prop-types';
import {observer} from 'mobx-react';
import isEmpty from 'lodash/isEmpty';
import IconButton from './iconButton/IconButton';
import Svg from './Svg';

const baseIconStyle = {
    width: '30px',
    height: '30px'
};

const svgContainerStyle = {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};

const baseButtonStyle = {
    height: '36px',
    minHeight: '36px',
    width: '36px',
    minWidth: '36px',
    clear: 'both',
    borderRadius: '50%',
    marginTop: '0 !important'
};

const SvgIconButton = ({icon, buttonStyle, onClick, disabled, iconStyle, backgroundColor, iconColor, rippleColor,
    hoverColor, viewBox, children, className, iconHoverColor, type, ...rest}) => (
    <IconButton
        style={{...baseButtonStyle, ...buttonStyle}} type={type} className={className}
        onClick={onClick} disabled={disabled} {...rest}>
        {isEmpty(children) ?
            <Svg
                iconStyle={{...baseIconStyle, ...iconStyle}}
                containerStyle={svgContainerStyle}
                viewBox={viewBox || '0 0 64 64'}
                hoverColor={iconHoverColor}
                color={iconColor}
                disabled={disabled}>
                {icon}</Svg> :
            <div>{children}</div>}
    </IconButton>
);

SvgIconButton.propTypes = {
    icon: PropTypes.object,
    buttonStyle: PropTypes.object,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    iconStyle: PropTypes.object,
    iconColor: PropTypes.string,
    rippleColor: PropTypes.string,
    hoverColor: PropTypes.string,
    viewBox: PropTypes.string,
    children: PropTypes.node,
    className: PropTypes.string,
    iconHoverColor: PropTypes.string,
    backgroundColor: PropTypes.string
};

export default observer(SvgIconButton);
